import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { format } from "date-fns";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";

import { useTodoStatusViewModal } from "./use-todo-status-view-modal";
import { getStatusOfTodoForEmployeeQueryOptions } from "@/config/queries/emp-query-options";
import { useMemo } from "react";
import { Button } from "@/components/ui/button/button";
import { Link } from "react-router-dom";

export const TodoStatusViewModal = () => {
  const { open, onOpenChange, todo, setTodo } = useTodoStatusViewModal();
  const key = Cookies.get("key") as string;

  const { data, isPending, isFetching } = useQuery(
    getStatusOfTodoForEmployeeQueryOptions(key, todo?.id as string)
  );

  const refineTodo = useMemo(() => {
    if (isPending) {
      return {};
    }

    if (data === undefined || data?.foundstatus === undefined || !todo) {
      return {};
    }

    const newRecipients = todo?.recipients?.map((re) => {
      const foundStatus =
        data?.foundstatus?.find((st) => st?.employee?._id === re?._id)
          ?.status || "Pending";

      return {
        ...re,
        status: foundStatus,
      };
    });

    const result = {
      ...todo,
      recipients: newRecipients,
    };

    return result;
  }, [data, todo, isPending, isFetching]) as {
    id: string;
    title: string;
    deadline: string;
    description: string;
    files: string[];
    recipients: {
      _id: string;
      name: string;
      status: string;
    }[];
  };

  return (
    <>
      <Dialog
        open={open}
        onOpenChange={(open) => {
          onOpenChange(open);
          if (!open) {
            setTodo(null);
          }
        }}
      >
        <DialogContent className="max-w-5xl">
          <DialogHeader>
            <DialogTitle className="tracking-normal">Progress</DialogTitle>
          </DialogHeader>

          <div className="flex flex-col gap-3">
            <div className="flex flex-row gap-1 items-center">
              <p className="shrink-0">Todo Name : </p>
              <p>{refineTodo?.title}</p>
            </div>
            <div className="flex flex-row gap-1 items-center">
              <p className="shrink-0">Todo Description : </p>
              <p className="text-sm">{refineTodo?.description}</p>
            </div>
            {refineTodo?.deadline && (
              <div className="flex flex-row gap-1 items-center">
                <p className="shrink-0">Todo Deadline : </p>
                <p className="">
                  {format(new Date(refineTodo?.deadline as string), "PPP")}
                </p>
              </div>
            )}

            <div className="flex flex-col gap-2">
              <h3 className="underline underline-offset-2">
                Recipients of TODO
              </h3>

              <div className="pl-4 flex flex-col gap-3 max-h-[500px] overflow-y-auto">
                {refineTodo?.recipients?.map((rec) => {
                  return (
                    <div
                      key={rec?._id}
                      className="px-3 py-2 rounded-md bg-accent flex items-center justify-between"
                    >
                      <div className="flex flex-col gap-2">
                        <div className="flex flex-row gap-1 items-center">
                          <p className="shrink-0">Recipient Name : </p>
                          <p>{rec?.name}</p>
                        </div>
                        <div className="flex flex-row gap-1 items-center text-sm">
                          <p className="shrink-0">Todo status : </p>
                          <p>{rec?.status}</p>
                        </div>
                      </div>

                      <div className="">
                        <Button size="sm" variant="ghost" className="" asChild>
                          <Link
                            to={`/admin/todos/employee-progress/${rec?._id}?n=${rec?.name}`}
                          >
                            View
                          </Link>
                        </Button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
